/* ============================================================
   Pawkeep — lógica de la landing
   Cambia BRAND para renombrar la marca en toda la página.
   ============================================================ */

const BRAND = "Pawkeep";

/* ---------- catálogo ---------- */

const FUR = [
  { id:"empty",     c:"rgba(255,255,255,0)", d:"rgba(255,255,255,0)", empty:true,
    name:{ es:"Vacía, como llega", en:"Empty, as it ships" } },
  { id:"golden",    c:"#E0A75E", d:"#B07B33", name:{ es:"Dorado",    en:"Golden" } },
  { id:"apricot",   c:"#C08552", d:"#8A5C33", name:{ es:"Canela",    en:"Apricot" } },
  { id:"chocolate", c:"#6B4A32", d:"#402C1C", name:{ es:"Chocolate", en:"Chocolate" } },
  { id:"black",     c:"#3B332C", d:"#1E1915", name:{ es:"Negro",     en:"Black" } },
  { id:"grey",      c:"#918B83", d:"#605A54", name:{ es:"Gris",      en:"Grey" } },
  { id:"cream",     c:"#EDE3D5", d:"#C3B4A2", name:{ es:"Crema",     en:"Cream" } },
  { id:"mixed",     c:"#B98A62", d:"#3B332C", name:{ es:"Mezcla",    en:"Mixed" } }
];

/* El catálogo sale de las variantes del producto en Shopify.
   Opción 1 = Formato, Opción 2 = Cantidad. */
const uniq = a => [...new Set(a)];

const EN_NAME = {
  "Caniche toy":"Toy poodle",
  "Pomeranian":"Pomeranian",
  "Golden Retriever":"Golden Retriever",
  "Negro":"Black", "Azul marino":"Navy blue", "Gris":"Grey", "Beige":"Beige",
  "1 unidad":"1 unit", "2 unidades":"2 units", "3 unidades":"3 units"
};
const label = (es, lang) => lang === "en" ? (EN_NAME[es] || es) : es;

/* Los nombres de las opciones vienen del producto: "Raza" en la figura,
   "Color" en el llavero. Así una sola plantilla sirve para los dos. */
const OPT_EN = { "Raza":"Breed", "Color":"Colour", "Cantidad":"Quantity", "Formato":"Format", "Talla":"Size" };
const optLabel = (i, L) => { const n = OPT[i] || ""; return L === "en" ? (OPT_EN[n] || n) : n; };

/* La pagina de productos trae varios (window.PK.products) y cambia de uno a
   otro con las pestañas; la portada y la ficha traen uno solo. */
const PKP = (window.PK && window.PK.products) || null;
let PKV = [], OPT = [], FORMATS = [], PACKS = [];
function useCatalog(p){
  PKV = (p && p.variants) || [];
  OPT = (p && p.options) || [];
  FORMATS = uniq(PKV.map(v => v.opt1)).map(n => ({ es:n }));
  PACKS   = uniq(PKV.map(v => v.opt2)).map(n => ({ es:n, qty: parseInt(n, 10) || 1 }));
}
useCatalog(PKP ? PKP[0] : window.PK);

/* Envío gratis a partir de 15 €, igual que la regla de la tienda. */
const FREE_FROM = 1500, SHIP = 395;

const variantAt = (f, p) =>
  PKV.find(v => FORMATS[f] && PACKS[p] && v.opt1 === FORMATS[f].es && v.opt2 === PACKS[p].es) || PKV[0] || null;

/* ---------- textos ---------- */

const T = {
  es:{
    "announce":"Envío gratis desde 15 € · 48-72 h en península",
    "nav.how":"Cómo funciona","nav.product":"El producto","nav.photos":"Fotos","nav.faq":"Preguntas","nav.cta":"Comprar","nav.cross":"Llavero de huella",

    "hero.eyebrow":"Con su propio pelo",
    "hero.title":"Guarda un mechón de tu perro.<br><em>Para siempre.</em>",
    "hero.sub":"Una miniatura transparente con la silueta de su raza. Dentro, su propio pelo. Un trozo de él que llevas contigo a todas partes.",
    "hero.cta1":"Quiero el mío","hero.cta2":"Ver cómo funciona",
    "hero.k1":"Alto","hero.v1":"4,2 cm",
    "hero.k2":"Peso","hero.v2":"12 g",
    "hero.k3":"Material","hero.v3":"Acrílico transparente",
    "hero.k4":"Cierre","hero.v4":"A presión, reabrible",
    "hero.c1":"Llega vacía y transparente.",
    "hero.c2":"Dentro va un mechón de su pelo.",
    "hero.c3":"Se cierra y va contigo en el llavero.",
    "hero.artCap":"Tres siluetas de raza: caniche toy, pomeranian y golden retriever. La figura llega vacía y transparente; el pelo lo pones tú en casa.",
    "figure.alt":"Miniatura transparente con forma de perro rellena con el pelo del animal",


    "how.eyebrow":"Tres minutos, una vez",
    "how.title":"Cómo se hace",
    "how.sub":"No hace falta enviarnos nada ni esperar semanas. Te llega la figura vacía y la rellenas tú, en tu casa, con tu perro al lado.",
    "how.s1.t":"Córtale un mechón pequeño",
    "how.s1.d":"Con un mechón del tamaño de una moneda sobra. Córtalo de una zona poco visible —el cuello, detrás de la oreja o la parte baja del lomo— y en unos días ni se nota.",
    "how.s1.n":"Si tu perro suelta mucho al cepillarlo, el pelo que queda en el cepillo sirve igual.",
    "how.s2.t":"Abre y rellena",
    "how.s2.d":"La figura se abre en dos mitades. Con unas pinzas finas (las de depilar sirven), coloca el pelo dentro y repártelo como quieras.",
    "how.s3.t":"Ciérralo y llévalo contigo",
    "how.s3.d":"Cierre a presión: encaja con un clic y no se abre solo. En las llaves, en la mochila o colgado del cuello.",

    "emo.eyebrow":"Cualquier perro, cualquier edad",
    "emo.title":"Da igual la edad<br>que tenga tu perro",
    "emo.p1":"Dos meses o doce años, contigo desde cachorro o adoptado la semana pasada. Lo único que hace falta es un mechón de su pelo.",
    "emo.p2":"Se monta en casa en cinco minutos, con él al lado. Luego lo enganchas a las llaves o a la mochila y te lo encuentras cada vez que sales de casa.",
    "emo.note":"Casi todo el mundo que guarda pelo de su perro lo hace tarde y a destiempo, con lo que encuentra en un cepillo. Esto es lo mismo, hecho mientras el perro sigue aquí y con un sitio decente donde meterlo.",

    "buy.eyebrow":"Configúralo",
    "buy.title":"Tu miniatura",
    "buy.photoCap":"Fotos de muestra. En la tienda hay tres siluetas: caniche toy, pomeranian y golden retriever.",
    "buy.noteFree":"IVA incluido · envío gratis",
    "buy.noteShip":"IVA incluido · + {SHIP} de envío",
    "pack.freeShip":"Envío gratis",
    "buy.previewLabel":"Previsualiza el resultado",
    "buy.previewCap":"Vista previa en 3D con la raza y el tono que elijas. Arrástrala para girarla.",
    "buy.view3d":"Vista previa en 3D",
    "buy.previewHint":"La figura llega vacía y transparente: el pelo lo pones tú. Elige aquí el tono del pelo de tu perro solo para hacerte una idea — no cambia lo que recibes ni el precio.",
    "buy.optionsLabel":"Opciones del pedido",
    "buy.shapeLabel":"Raza",
    "buy.packLabel":"Cantidad",
    "buy.add":"Añadir al carrito",
    "buy.soldOut":"Agotado",
    "buy.inc1":"Miniatura de acrílico transparente, hueca y con cierre a presión",
    "buy.inc2":"Anilla de acero inoxidable",

    "spec.shipL":"Envío","spec.shipV":"Gratis desde 15 €. Por debajo, 3,95 €",
    "spec.timeL":"Plazo","spec.timeV":"48-72 h en península",
    "spec.retL":"Devolución","spec.retV":"30 días, aunque ya la hayas rellenado",

    "gal.eyebrow":"Fotos reales","gal.title":"Cómo queda",
    "gal.sub":"El producto tal y como llega y una vez relleno. Todavía no tenemos opiniones publicadas: la tienda acaba de abrir y aún no hemos servido pedidos.",
    "gal.c1":"Cuatro figuras en la mano: una ya rellena y tres todavía vacías.",
    "gal.c3":"Pomeranian blanco relleno, en el asa de un bolso.",
    "gal.c4":"Varias ya rellenas, en el llavero del día a día.",

    "conf.eyebrow":"Antes de comprar",
    "conf.title":"Envíos, devoluciones y pago",
    "conf.shipT":"Envíos",
    "conf.shipD":"Sale del almacén y llega a tu casa. No hay que enviarnos nada ni concertar recogidas.",
    "conf.ship.k1":"Gratis","conf.ship.v1":"A partir de 15 € de pedido",
    "conf.ship.k2":"Por debajo de 15 €","conf.ship.v2":"3,95 € de gastos de envío",
    "conf.ship.k3":"Plazo","conf.ship.v3":"48-72 h en península. Para Baleares, Canarias, Ceuta y Melilla, escríbenos antes de pedir.",
    "conf.retT":"Devoluciones",
    "conf.retD":"Treinta días desde que lo recibes. Si ya lo has rellenado con pelo no es problema: lo vacías, nos lo devuelves y te reintegramos el importe íntegro. El pelo se queda contigo.",
    "conf.retLink":"Leer la política de devoluciones",
    "conf.payT":"Pago",
    "conf.payD":"El cobro se hace en el checkout de Shopify, fuera de esta página. Aquí no se introducen ni se guardan datos de tarjeta.",
    "conf.payTodo":"[PENDIENTE] Falta configurar Shopify Payments y enumerar aquí los métodos de pago que queden activos.",

    "faq.eyebrow":"Dudas razonables","faq.title":"Preguntas frecuentes",

    "buy.titleDual":"Tu pedido",
    "buy.none":"Elige al menos uno",
    "item.figura":"Figura acrílica","item.huella":"Llavero de huella",
    "item.figuraSw":"Incluir la figura acrílica","item.huellaSw":"Incluir el llavero de huella",
    "item.huellaOff":"Piel sintética con la huella troquelada; su pelo se ve a través. Actívalo para añadirlo al mismo pedido.",
    "extra.colorLabel":"Color",
    "extra.view3d":"Llavero de huella en 3D",
    "extra.previewCap":"Vista previa en 3D del llavero con el color y el tono que elijas. Arrástralo para girarlo.",
    "huella.eyebrow":"El llavero de huella",
    "huella.title":"Su huella.<br><em>Con su pelo dentro.</em>",
    "huella.sub":"Piel sintética con la huella troquelada y una lámina transparente detrás. Desabrochas el botón, metes un mechón por arriba y su pelo asoma por la huella.",
    "huella.cta":"Ver el llavero de huella",
    "huella.colores":"Colores del llavero","huella.negro":"Negro","huella.azul":"Azul marino","huella.gris":"Gris","huella.beige":"Beige",
    "huella.k1":"Material","huella.v1":"Piel sintética",
    "huella.k2":"Cierre","huella.v2":"Botón a presión",
    "huella.k3":"Colores","huella.v3":"Cuatro",
    "huella.k4":"Formato","huella.v4":"Plano, con anilla",
    "huella.c1":"Llega vacío, con la huella troquelada.",
    "huella.c2":"Se desabrocha arriba y entra su pelo.",
    "huella.c3":"Clic, y en el color que elijas.",
    "huella.alt":"Llavero de piel con forma de huella; a través de la huella troquelada se ve el pelo del perro",
    "cross.eyebrow":"También con su pelo",
    "cross.text":"Plano, de piel sintética y con la huella troquelada. Cabe en el llavero sin abultar y viene en cuatro colores: negro, azul marino, gris y beige.",
    "cross.from":"Desde",
    "cross.k1":"Material","cross.v1":"Piel sintética",
    "cross.k2":"Colores","cross.v2":"Negro, azul marino, gris o beige",
    "cross.k3":"Formato","cross.v3":"Plano, con la huella troquelada",
    "cross.cta":"Ver el llavero de huella",
    "prod.back":"Volver a la portada",
    "nav.shop":"Productos","foot.shopAll":"Todos los productos",
    "nav.figSub":"Caniche toy, pomeranian o golden retriever","nav.keySub":"Negro, azul marino, gris o beige",
    "shop.title":"Productos",
    "shop.tabsLabel":"Elige producto",
    "shop.tab1":"Figura de acrílico","shop.tab1s":"Figura",
    "shop.tab2":"Llavero de piel sintética","shop.tab2s":"Llavero",

    "final.title":"Un trozo de tu perro,<br>siempre encima",
    "final.sub":"Cinco minutos en casa, con él al lado. Después vive en tus llaves.",
    "final.cta":"Quiero el mío",
    "final.note":"IVA incluido. Envío gratis desde 15 €. Treinta días para devolverlo.",

    "sticky.cta":"Añadir",
    "toast.added":"Añadido al carrito",
    "cart.title":"Tu carrito","cart.empty":"Tu carrito está vacío.","cart.browse":"Ver productos",
    "cart.each":"/ unidad","cart.remove":"Quitar","cart.less":"Una menos","cart.more":"Una más",
    "cart.subtotal":"Subtotal","cart.ship":"Envío a España","cart.free":"Gratis","cart.shipCost":"3,95 €",
    "cart.shipNote":"Gratis a partir de 15 €. A otros países se calcula al pagar.",
    "cart.total":"Total","cart.tax":"IVA incluido","cart.checkout":"Pagar","cart.keep":"Seguir comprando",

    "foot.tag":"Recuerdos de perro hechos con su propio pelo. Tienda abierta en 2026.",
    "foot.shopT":"Tienda","foot.shop1":"Miniatura de pelo","foot.shop2":"Cómo funciona","foot.shop3":"Preguntas frecuentes","foot.shop4":"Llavero de huella",
    "foot.helpT":"Ayuda","foot.help1":"Envíos y entregas","foot.help2":"Devoluciones","foot.help3":"Contacto","foot.help4":"Aviso legal y privacidad",
    "foot.dataT":"Datos de la empresa",
    "foot.legal":"[PENDIENTE] Razón social, NIF y domicilio fiscal. Hay que rellenarlos en las cinco páginas legales antes de quitar la contraseña de la tienda.",
    "foot.rights":"© 2026 " + BRAND + ". Todos los derechos reservados.",
    "foot.made":"Precios con IVA incluido."
  },

  en:{
    "announce":"Free shipping over €15 · 2-3 working days in mainland Spain",
    "nav.how":"How it works","nav.product":"The product","nav.photos":"Photos","nav.faq":"FAQ","nav.cta":"Buy now","nav.cross":"Paw keyring",

    "hero.eyebrow":"Made with their own fur",
    "hero.title":"Keep a lock of your dog.<br><em>Forever.</em>",
    "hero.sub":"A tiny clear figurine shaped like their breed. Inside, their own fur. A piece of them you carry everywhere.",
    "hero.cta1":"Get mine","hero.cta2":"See how it works",
    "hero.k1":"Height","hero.v1":"4.2 cm",
    "hero.k2":"Weight","hero.v2":"12 g",
    "hero.k3":"Material","hero.v3":"Clear acrylic",
    "hero.k4":"Closure","hero.v4":"Snap-fit, reopenable",
    "hero.c1":"It arrives empty and clear.",
    "hero.c2":"A lock of their fur goes inside.",
    "hero.c3":"Snap it shut and it goes on your keys.",
    "hero.artCap":"Three breed silhouettes: toy poodle, pomeranian and golden retriever. The figurine arrives empty and clear — you add the fur at home.",
    "figure.alt":"Clear dog-shaped miniature filled with the pet's own fur",


    "how.eyebrow":"Three minutes, once",
    "how.title":"How it's made",
    "how.sub":"Nothing to mail in, nothing to wait weeks for. The figurine arrives empty and you fill it yourself, at home, with your dog right there.",
    "how.s1.t":"Cut one small lock",
    "how.s1.d":"A lock the size of a coin is plenty. Take it from somewhere that doesn't show — the neck, behind an ear, the lower back — and it grows back within days.",
    "how.s1.n":"If your dog sheds a lot when brushed, the fur left in the brush works just as well.",
    "how.s2.t":"Open it and fill it",
    "how.s2.d":"The figurine splits into two halves. Use a pair of fine tweezers (eyebrow tweezers work) to place the fur inside and arrange it however you like.",
    "how.s3.t":"Close it and carry it",
    "how.s3.d":"Snap closure: it clicks shut and stays shut. On your keys, on your bag, or around your neck.",

    "emo.eyebrow":"Any dog, any age",
    "emo.title":"Your dog's age<br>doesn't matter",
    "emo.p1":"Two months old or twelve years, with you since a puppy or adopted last week. All it takes is a small lock of their fur.",
    "emo.p2":"You put it together at home in five minutes, with them next to you. Then it clips onto your keys or your bag, and you come across it every time you head out.",
    "emo.note":"Most people who keep their dog's fur do it late and by accident, with whatever is left in a brush. This is the same thing, done while the dog is still here and with somewhere decent to put it.",

    "buy.eyebrow":"Build yours",
    "buy.title":"Your miniature",
    "buy.photoCap":"Sample photos. The shop carries three silhouettes: toy poodle, pomeranian and golden retriever.",
    "buy.noteFree":"Taxes included · free shipping",
    "buy.noteShip":"Taxes included · + {SHIP} shipping",
    "pack.freeShip":"Free shipping",
    "buy.previewLabel":"Preview the result",
    "buy.previewCap":"3D preview in the breed and shade you pick. Drag to turn it.",
    "buy.view3d":"3D preview",
    "buy.previewHint":"The figurine arrives empty and clear — the fur is yours to add. Pick your dog's coat shade here just to picture it; it doesn't change what you receive or the price.",
    "buy.optionsLabel":"Order options",
    "buy.shapeLabel":"Breed",
    "buy.packLabel":"Quantity",
    "buy.add":"Add to cart",
    "buy.soldOut":"Sold out",
    "buy.inc1":"Clear acrylic miniature, hollow, with a snap closure",
    "buy.inc2":"Stainless steel ring",

    "spec.shipL":"Shipping","spec.shipV":"Free over €15. Below that, €3.95",
    "spec.timeL":"Delivery","spec.timeV":"2-3 working days in mainland Spain",
    "spec.retL":"Returns","spec.retV":"30 days, even once you have filled it",

    "gal.eyebrow":"Real photos","gal.title":"How it turns out",
    "gal.sub":"The product as it arrives and once filled. No published reviews yet — the shop has only just opened and we have not shipped any orders.",
    "gal.c1":"Four figurines in one hand: one already filled, three still empty.",
    "gal.c3":"A white Pomeranian, filled, on a tote bag handle.",
    "gal.c4":"Several filled ones on an everyday keyring.",

    "conf.eyebrow":"Before you buy",
    "conf.title":"Shipping, returns and payment",
    "conf.shipT":"Shipping",
    "conf.shipD":"It ships from the warehouse straight to you. Nothing to send us, no collections to arrange.",
    "conf.ship.k1":"Free","conf.ship.v1":"On orders over €15",
    "conf.ship.k2":"Under €15","conf.ship.v2":"€3.95 shipping",
    "conf.ship.k3":"Delivery","conf.ship.v3":"2-3 working days in mainland Spain. For the Balearics, Canaries, Ceuta and Melilla, write to us before ordering.",
    "conf.retT":"Returns",
    "conf.retD":"Thirty days from delivery. If you have already filled it with fur that is fine: empty it, send it back and we refund you in full. The fur stays with you.",
    "conf.retLink":"Read the returns policy",
    "conf.payT":"Payment",
    "conf.payD":"Payment is taken in Shopify's checkout, away from this page. No card details are entered or stored here.",
    "conf.payTodo":"[PENDING] Shopify Payments still needs configuring, and the accepted payment methods listing here.",

    "faq.eyebrow":"Fair questions","faq.title":"Frequently asked",

    "buy.titleDual":"Your order",
    "buy.none":"Choose at least one",
    "item.figura":"Clear figurine","item.huella":"Paw keyring",
    "item.figuraSw":"Include the clear figurine","item.huellaSw":"Include the paw keyring",
    "item.huellaOff":"Synthetic leather with the paw cut out; their fur shows through. Switch it on to add it to the same order.",
    "extra.colorLabel":"Colour",
    "extra.view3d":"Paw keyring in 3D",
    "extra.previewCap":"3D preview of the keyring in the colour and shade you pick. Drag to turn it.",
    "huella.eyebrow":"The paw keyring",
    "huella.title":"Their paw.<br><em>With their fur inside.</em>",
    "huella.sub":"Synthetic leather with the paw cut out and a clear window behind it. Undo the snap, tuck a lock of fur in at the top and it shows through the paw.",
    "huella.cta":"See the paw keyring",
    "huella.colores":"Keyring colours","huella.negro":"Black","huella.azul":"Navy blue","huella.gris":"Grey","huella.beige":"Beige",
    "huella.k1":"Material","huella.v1":"Synthetic leather",
    "huella.k2":"Closure","huella.v2":"Snap button",
    "huella.k3":"Colours","huella.v3":"Four",
    "huella.k4":"Format","huella.v4":"Flat, on a ring",
    "huella.c1":"It arrives empty, with the paw cut out.",
    "huella.c2":"Undo it at the top and their fur goes in.",
    "huella.c3":"Snap. In the colour you choose.",
    "huella.alt":"Paw-shaped leather keyring; their fur shows through the cut-out paw",
    "cross.eyebrow":"Also with their fur",
    "cross.text":"Flat, in synthetic leather, with the paw shape cut out. It sits on your keys without bulk and comes in four colours: black, navy blue, grey and beige.",
    "cross.from":"From",
    "cross.k1":"Material","cross.v1":"Synthetic leather",
    "cross.k2":"Colours","cross.v2":"Black, navy blue, grey or beige",
    "cross.k3":"Format","cross.v3":"Flat, with the paw shape cut out",
    "cross.cta":"See the paw keyring",
    "prod.back":"Back to the homepage",
    "nav.shop":"Products","foot.shopAll":"All products",
    "nav.figSub":"Toy poodle, pomeranian or golden retriever","nav.keySub":"Black, navy blue, grey or beige",
    "shop.title":"Products",
    "shop.tabsLabel":"Choose a product",
    "shop.tab1":"Acrylic figure","shop.tab1s":"Figure",
    "shop.tab2":"Faux leather keyring","shop.tab2s":"Keyring",

    "final.title":"A piece of your dog,<br>always on you",
    "final.sub":"Five minutes at home, with them beside you. After that it lives on your keys.",
    "final.cta":"Get mine",
    "final.note":"Taxes included. Free shipping over €15. Thirty days to send it back.",

    "sticky.cta":"Add",
    "toast.added":"Added to cart",
    "cart.title":"Your cart","cart.empty":"Your cart is empty.","cart.browse":"See products",
    "cart.each":"each","cart.remove":"Remove","cart.less":"One fewer","cart.more":"One more",
    "cart.subtotal":"Subtotal","cart.ship":"Shipping to Spain","cart.free":"Free","cart.shipCost":"€3.95",
    "cart.shipNote":"Free over €15. Other countries: calculated at checkout.",
    "cart.total":"Total","cart.tax":"Taxes included","cart.checkout":"Checkout","cart.keep":"Keep shopping",

    "foot.tag":"Dog keepsakes made from their own fur. Shop opened in 2026.",
    "foot.shopT":"Shop","foot.shop1":"Fur miniature","foot.shop2":"How it works","foot.shop3":"FAQ","foot.shop4":"Paw keyring",
    "foot.helpT":"Help","foot.help1":"Shipping","foot.help2":"Returns","foot.help3":"Contact","foot.help4":"Legal & privacy",
    "foot.dataT":"Company details",
    "foot.legal":"[PENDING] Registered name, tax number and registered address. These must be filled in across the five legal pages before the shop password is removed.",
    "foot.rights":"© 2026 " + BRAND + ". All rights reserved.",
    "foot.made":"All prices include VAT."
  }
};

/* ---------- faq ---------- */

const FAQ = {
  es:[
    { q:"¿Tengo que cortarle el pelo a mi perro?", a:"Sí, un mechón pequeño. Con algo del tamaño de una moneda es más que suficiente para llenar la figura. Usa unas tijeras de punta roma y córtalo de una zona poco visible: el cuello, detrás de la oreja o la parte baja del lomo. No le duele y en unos días vuelve a estar igual. Si tu perro suelta mucho al cepillarlo, también puedes aprovechar el del cepillo." },
    { q:"¿Sirve si mi perro ya no está conmigo?", a:"Sí, exactamente igual. Mucha gente lo hace con pelo que guardó en un sobre, en un collar o en el cepillo. Con cualquier cantidad, por pequeña que sea, funciona." },
    { q:"¿El pelo se estropea con el tiempo?", a:"No. El pelo es queratina: seco y aislado del aire y de la humedad no se descompone ni pierde color. Solo hay que asegurarse de que esté limpio y seco antes de meterlo." },
    { q:"¿Se puede volver a abrir?", a:"Sí. El cierre es a presión y se puede reabrir con cuidado si quieres añadir más pelo o recolocarlo. No se abre solo con el uso diario." },
    { q:"¿Se parecerá a mi perro?", a:"Bastante. Cada figura está moldeada con la silueta de una raza concreta —caniche toy, pomeranian o golden retriever—, así que eliges la que más se parezca al tuyo. Y lo que la hace suya de verdad es su propio pelo dentro, que se ve a través del acrílico. Si tu perro es mestizo, elige la silueta más cercana a su tamaño y pelaje." },
    { q:"¿Cuánto tarda en llegar?", a:"48-72 horas en península una vez sale del almacén. Te enviamos el número de seguimiento por email en cuanto se despacha." },
    { q:"¿Puedo devolverlo?", a:"Sí, tienes 30 días. Si ya lo has rellenado con pelo no pasa nada: nos lo dices, lo vacías y te devolvemos el importe igualmente." }
  ],
  en:[
    { q:"Do I have to cut my dog's fur?", a:"Yes, one small lock. Something coin-sized is more than enough to fill the figurine. Use blunt-tipped scissors and take it from a spot that doesn't show: the neck, behind an ear, or the lower back. It doesn't hurt them and it grows back within days. If your dog sheds a lot when brushed, fur from the brush works too." },
    { q:"Does it work if my dog isn't with me anymore?", a:"Yes, exactly the same. Plenty of people use fur they kept in an envelope, on a collar, or in the brush. Any amount at all works." },
    { q:"Does the fur deteriorate over time?", a:"No. Fur is keratin: kept dry and sealed away from air and moisture, it doesn't break down or lose colour. Just make sure it's clean and dry before you seal it in." },
    { q:"Can it be reopened?", a:"Yes. The snap closure can be carefully reopened if you want to add more fur or rearrange it. It won't come open on its own with daily use." },
    { q:"Will it look like my dog?", a:"Quite a lot. Each figurine is moulded in the silhouette of a specific breed — toy poodle, pomeranian or golden retriever — so you pick the one closest to yours. What really makes it theirs is their own fur inside, visible through the acrylic. If your dog is a mix, pick the silhouette closest to their size and coat." },
    { q:"How long does shipping take?", a:"2-3 business days once it leaves the warehouse. You get a tracking number by email as soon as it ships." },
    { q:"Can I return it?", a:"Yes, you have 30 days. If you've already filled it with fur that's fine — let us know, empty it, and we'll refund you all the same." }
  ]
};

/* ============================================================
   estado
   ============================================================ */

const state = {
  lang: localStorage.getItem("pk-lang") || "es",
  fur: 1,
  format: 0,
  pack: 1,
  /* el configurador de la portada lleva los dos productos */
  conFigura: true,
  huella: { on: false, color: 0, pack: 0 }
};

const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

const money = (cents, lang) =>
  lang === "es"
    ? (cents / 100).toFixed(2).replace(".", ",") + " €"
    : "€" + (cents / 100).toFixed(2);

const t = k => T[state.lang][k] ?? k;

/* ============================================================
   render
   ============================================================ */

/* ============================================================
   el llavero de huella, en el mismo configurador que la figura
   En la tienda sus variantes llegan en window.PK.huella (Color ×
   Cantidad); en la maqueta, sin window.PK, se inventan aquí con los
   precios de la tienda. Todo esto solo actúa si hay [data-extra].
   ============================================================ */
const HUELLA_V = window.PK ? (window.PK.huella || []) : (() => {
  let id = 1;
  return ["Negro", "Azul marino", "Gris", "Beige"].flatMap(c =>
    [["1 unidad", 799], ["2 unidades", 1549], ["3 unidades", 1999]].map(([q, p]) =>
      ({ id: id++, opt1: c, opt2: q, price: p, available: true, image: null })));
})();
const H_COLORES = [...new Set(HUELLA_V.map(v => v.opt1))];
const H_PACKS = [...new Set(HUELLA_V.map(v => v.opt2))];
const H_EN = { "Negro":"Black", "Azul marino":"Navy blue", "Gris":"Grey", "Beige":"Beige",
               "1 unidad":"1 unit", "2 unidades":"2 units", "3 unidades":"3 units" };
const hLabel = (es, L) => L === "en" ? (H_EN[es] || es) : es;
const hQty = n => parseInt(n, 10) || 1;
const hVar = (c, p) => HUELLA_V.find(v => v.opt1 === H_COLORES[c] && v.opt2 === H_PACKS[p]) || null;
/* color de la variante -> piel del 3D (dog.js) y muestra */
const cueroDe = n => /negro|black/i.test(n) ? "negro" : /azul|navy/i.test(n) ? "azul" : /gris|grey|gray/i.test(n) ? "gris" : "beige";
const CUERO_HEX = { negro:"#161413", azul:"#1f2742", gris:"#7d7c7a", beige:"#cdb593" };
const ENVIO_DESDE = 1500, ENVIO = 395;

const hayHuella = () => !!$("[data-extra]") && HUELLA_V.length > 0;
const huellaOn = () => hayHuella() && state.huella.on;
const figuraOn = () => !hayHuella() || state.conFigura;
function huellaTotal(){ const v = huellaOn() ? hVar(state.huella.color, state.huella.pack) : null; return v ? v.price : 0; }
function figuraTotal(){ return figuraOn() ? currentTotal() : 0; }
const pedidoTotal = () => figuraTotal() + huellaTotal();

/* el llavero entra como la figura: N sueltos, y el precio del pack lo ponen
   los descuentos automáticos de la tienda */
function huellaLineas(){
  if(!huellaOn()) return [];
  const v = hVar(state.huella.color, state.huella.pack);
  if(!v) return [];
  const n = hQty(v.opt2), i = H_PACKS.findIndex(q => hQty(q) === 1);
  const one = n > 1 && i >= 0 ? hVar(state.huella.color, i) : null;
  return [one ? { id: one.id, quantity: n } : { id: v.id, quantity: 1 }];
}

function renderExtra(){
  const box = $("[data-extra]");
  if(!box) return;
  if(!HUELLA_V.length){ box.hidden = true; return; }
  const L = state.lang, h = state.huella;
  box.classList.toggle("is-off", !h.on);
  $('[data-sw="huella"]').setAttribute("aria-checked", String(h.on));
  $("[data-extra-colors]").innerHTML = H_COLORES.map((c, i) => `
    <button type="button" class="cueros__b" data-hcolor="${i}" aria-pressed="${i === h.color}"
      style="--c:${CUERO_HEX[cueroDe(c)]}" aria-label="${hLabel(c, L)}" title="${hLabel(c, L)}"></button>`).join("");
  $("[data-extra-color-name]").textContent = hLabel(H_COLORES[h.color] || "", L);
  const each = L === "es" ? "por unidad" : "each", shipWord = L === "es" ? "de envío" : "shipping";
  $("[data-extra-packs]").innerHTML = H_PACKS.map((q, i) => {
    const v = hVar(h.color, i);
    if(!v) return "";
    const n = hQty(q), free = v.price + figuraTotal() >= ENVIO_DESDE;
    return `
    <button type="button" class="pack" data-hpack="${i}" aria-pressed="${i === h.pack}">
      <span class="pack__dot"></span>
      <span>
        <span class="pack__t">${hLabel(q, L)}</span>
        ${n > 1 ? `<span class="pack__s">${money(Math.round(v.price / n), L)} ${each}</span>` : ""}
        ${free ? `<span class="pack__ship">${t("pack.freeShip")}</span>`
               : `<span class="pack__ship pack__ship--paid">+ ${money(ENVIO, L)} ${shipWord}</span>`}
      </span>
      <span class="pack__p">${money(v.price, L)}</span>
    </button>`;
  }).join("");
  /* la piel del llavero 3D sigue al color elegido */
  const cuero = cueroDe(H_COLORES[h.color] || "");
  if(document.documentElement.dataset.cuero !== cuero){
    document.documentElement.dataset.cuero = cuero;
    document.dispatchEvent(new CustomEvent("pk:cuero"));
  }
}

/* precio total, envío y botón: lo que esté encendido de los dos */
function renderPedido(){
  if(!hayHuella() || !$("[data-price]")) return;
  const L = state.lang, total = pedidoTotal();
  const fig = $('[data-item="figura"]');
  if(fig) fig.classList.toggle("is-off", !state.conFigura);
  const sw = $('[data-sw="figura"]');
  if(sw) sw.setAttribute("aria-checked", String(state.conFigura));
  const fp = $('[data-item-price="figura"]'), hp = $('[data-item-price="huella"]');
  if(fp) fp.textContent = state.conFigura ? money(currentTotal(), L) : "";
  if(hp) hp.textContent = state.huella.on ? money(huellaTotal(), L)
    : (HUELLA_V.length ? (L === "es" ? "desde " : "from ") + money(Math.min(...HUELLA_V.map(v => v.price)), L) : "");
  $("[data-price]").textContent = money(total, L);
  $(".price-note").textContent = !total ? "" : total >= ENVIO_DESDE
    ? t("buy.noteFree") : t("buy.noteShip").replace("{SHIP}", money(ENVIO, L));
  const fv = typeof currentVariant === "function" ? currentVariant() : null;
  const hv = huellaOn() ? hVar(state.huella.color, state.huella.pack) : null;
  const agotado = (figuraOn() && fv && !fv.available) || (hv && !hv.available);
  $$("[data-add]").forEach(b => {
    b.textContent = !total ? t("buy.none") : t(agotado ? "buy.soldOut" : "buy.add");
    b.disabled = !total || !!agotado;
  });
  const sp = $("[data-sticky-price]");
  if(sp) sp.textContent = money(total, L);
}

/* la vista 3D del llavero en la galería de la compra */
function verHuella(){
  const v = $('.galeria [data-vista="huella"]');
  if(v && v.getAttribute("aria-pressed") !== "true") setVista(v);
}

function renderStatic(){
  document.documentElement.lang = state.lang;
  $$("[data-brand]").forEach(el => el.textContent = BRAND);
  $$("[data-i18n]").forEach(el => el.textContent = t(el.dataset.i18n));
  $$("[data-i18n-html]").forEach(el => el.innerHTML = t(el.dataset.i18nHtml));
  $$("[data-i18n-ph]").forEach(el => el.placeholder = t(el.dataset.i18nPh));
  $$("[data-i18n-aria]").forEach(el => el.setAttribute("aria-label", t(el.dataset.i18nAria)));
  $$(".dog").forEach(el => el.setAttribute("aria-label", t("figure.alt")));
  $$(".lang button").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.lang === state.lang)));
  document.dispatchEvent(new CustomEvent("pk:lang"));

  /* en Shopify los rótulos salen del propio producto: "Raza" o "Color" */
  if(typeof OPT !== "undefined"){
    const l1 = $("[data-i18n='buy.shapeLabel']"), l2 = $("[data-i18n='buy.packLabel']");
    if(l1 && OPT[0]) l1.textContent = optLabel(0, state.lang);
    if(l2 && OPT[1]) l2.textContent = optLabel(1, state.lang);
  }
}

function renderSwatches(){
  const box = $("[data-swatches]");
  if(!box) return;
  box.innerHTML = FUR.map((f, i) => `
    <button type="button" class="swatch${f.empty ? " swatch--empty" : ""}"
      style="--sw:linear-gradient(140deg,${f.c},${f.d})"
      data-i="${i}" aria-pressed="${i === state.fur}" title="${f.name[state.lang]}">
      <i></i><span class="visually-hidden">${f.name[state.lang]}</span>
    </button>`).join("");
  $("[data-fur-name]").textContent = FUR[state.fur].name[state.lang];
}

function renderFormats(){
  if(!$("[data-shapes]")) return;
  const L = state.lang, base = variantAt(0, state.pack);
  $("[data-shapes]").innerHTML = FORMATS.map((f, i) => {
    const v = variantAt(i, state.pack);
    const extra = v && base ? v.price - base.price : 0;
    return `<button type="button" class="chip" data-i="${i}" aria-pressed="${i === state.format}">
      ${label(f.es, L)}${extra > 0 ? " +" + money(extra, L) : ""}
    </button>`;
  }).join("");
  $("[data-shape-name]").textContent = label(FORMATS[state.format].es, L);
}

function renderPacks(){
  if(!$("[data-packs]")) return;
  const L = state.lang;
  /* "por unidad" vale para la figura y para el llavero */
  const eachWord = L === "es" ? "por unidad" : "each";
  const shipWord = L === "es" ? "de envío" : "shipping";

  /* Sin precio tachado, sin porcentaje de ahorro y sin etiqueta de "mas
     elegido": el precio por unidad es un dato, no un reclamo. */
  $("[data-packs]").innerHTML = PACKS.map((p, i) => {
    const v = variantAt(state.format, i);
    if(!v) return "";
    /* con el llavero en el mismo pedido, el envío gratis se mira sobre el total */
    const free = v.price + huellaTotal() >= FREE_FROM;
    return `
    <button type="button" class="pack" data-i="${i}" aria-pressed="${i === state.pack}">
      <span class="pack__dot"></span>
      <span>
        <span class="pack__t">${label(p.es, L)}</span>
        ${p.qty > 1 ? `<span class="pack__s">${money(Math.round(v.price / p.qty), L)} ${eachWord}</span>` : ""}
        ${free
          ? `<span class="pack__ship">${t("pack.freeShip")}</span>`
          : `<span class="pack__ship pack__ship--paid">+ ${money(SHIP, L)} ${shipWord}</span>`}
      </span>
      <span class="pack__p">${money(v.price, L)}</span>
    </button>`;
  }).join("");
}


function currentVariant(){ return variantAt(state.format, state.pack); }
function currentTotal(){ const v = currentVariant(); return v ? v.price : 0; }

function renderPrice(){
  const L = state.lang, v = currentVariant();
  if(!v || !$("[data-price]")) return;

  $("[data-price]").textContent = money(v.price, L);

  $(".price-note").textContent = v.price >= FREE_FROM
    ? t("buy.noteFree")
    : t("buy.noteShip").replace("{SHIP}", money(SHIP, L));

  $$("[data-add]").forEach(a => {
    a.textContent = t(v.available ? "buy.add" : "buy.soldOut");
    a.disabled = !v.available;
  });

  const sp = $("[data-sticky-price]"), sn = $("[data-sticky-name]");
  if(sp) sp.textContent = money(v.price, L);
  if(sn) sn.textContent = label(FORMATS[state.format].es, L);
  fotoVariante(v);
  renderPedido();
}

/* Si la variante tiene foto propia (el llavero de huella, una por color), la
   foto grande de la galería visible pasa a esa; la figura 3D no se toca. */
function fotoVariante(v){
  if(!v || !v.image) return;
  const fig = $$(".galeria").find(g => !g.hidden && !g.classList.contains("is-3d"));
  const main = fig ? $("[data-galeria-main]", fig) : $("#pkMain");
  if(!main) return;
  const base = u => (u || "").split("?")[0].replace(/^https?:/, "");
  if(base(main.currentSrc || main.src) !== base(v.image)) swapImage(main, v.image, main.alt);
  const thumbs = fig ? $$(".galeria__thumbs button", fig) : $$(".pk-thumbs button");
  thumbs.forEach(t => t.setAttribute("aria-pressed", String(base(t.dataset.full) === base(v.image))));
}

function renderFur(){
  const f = FUR[state.fur];
  document.documentElement.style.setProperty("--fur", f.c);
  document.documentElement.style.setProperty("--fur-dark", f.d);
  /* la figura 3D del hero lee estos colores: se le avisa para que se repinte */
  document.dispatchEvent(new CustomEvent("pk:fur"));
}

/* Miniatura pulsada -> foto grande. En la portada la primera es la figura 3D
   (data-vista="3d"): se enseña encima y la foto se queda debajo, sin cambiar. */
function setVista(thumb){
  /* en la pagina de productos hay una galeria por pestaña */
  const fig = thumb.closest(".galeria") || document;
  const isH = thumb.dataset.vista === "huella";
  const is3d = thumb.dataset.vista === "3d" || isH;
  if(fig.classList){ fig.classList.toggle("is-3d", is3d); fig.classList.toggle("is-huella", isH); }
  const main = $("[data-galeria-main]", fig);
  if(main && !is3d) swapImage(main, thumb.dataset.full, thumb.dataset.alt || "");
  $$(".galeria__thumbs button", fig).forEach(b => b.setAttribute("aria-pressed", String(b === thumb)));
}

/* al cambiar tono o raza, si se estaba viendo una foto, la foto grande vuelve a la figura */
function verFigura(){
  const v3d = $('.galeria [data-vista="3d"]');
  if(v3d && v3d.getAttribute("aria-pressed") !== "true") setVista(v3d);
}

/* Raza elegida -> molde de la figura 3D de la compra (el hero sigue siendo el
   caniche). Vale para el catálogo de la maqueta y para el de Shopify, que
   solo trae el nombre en castellano. */
function renderRaza(){
  const f = FORMATS[state.format];
  const n = f ? (f.es || (f.name && f.name.es) || "") : "";
  const raza = /pomer/i.test(n) ? "pomerania" : /golden/i.test(n) ? "golden" : "caniche";
  if(document.documentElement.dataset.raza === raza) return;
  document.documentElement.dataset.raza = raza;
  document.dispatchEvent(new CustomEvent("pk:raza"));
}


function renderFaq(){
  if(!$("[data-faq]")) return;
  $("[data-faq]").innerHTML = FAQ[state.lang].map((f, i) => `
    <div class="faq__item">
      <button type="button" class="faq__q" aria-expanded="false" aria-controls="fa-${i}">${f.q}</button>
      <div class="faq__a" id="fa-${i}"><p>${f.a}</p></div>
    </div>`).join("");
}

function renderAll(){
  renderDogs();
  renderStatic();
  renderSwatches();
  renderFormats();
  renderPacks();
  renderExtra();
  renderPrice();
  renderFur();
  renderRaza();
  renderFaq();
  /* al cambiar de idioma los titulares partidos en lineas se rehacen */
  if(window.pkMotion) window.pkMotion.refresh();
}

/* ============================================================
   eventos
   ============================================================ */

document.addEventListener("click", e => {
  const lang = e.target.closest(".lang button");
  if(lang){
    state.lang = lang.dataset.lang;
    localStorage.setItem("pk-lang", state.lang);
    renderAll();
    return;
  }

  const sw = e.target.closest("[data-swatches] .swatch");
  if(sw){ state.fur = +sw.dataset.i; renderSwatches(); renderFur(); renderPrice(); verFigura(); return; }

  const chip = e.target.closest("[data-shapes] .chip");
  if(chip){ state.format = +chip.dataset.i; renderFormats(); renderPrice(); renderRaza(); verFigura(); return; }

  const pack = e.target.closest("[data-packs] .pack");
  if(pack){ state.pack = +pack.dataset.i; renderPacks(); renderExtra(); renderPrice(); verFigura(); return; }

  /* los dos interruptores; con uno apagado su bloque se pliega */
  const inter = e.target.closest("[data-sw]");
  if(inter){
    if(inter.dataset.sw === "huella"){ state.huella.on = !state.huella.on; if(state.huella.on) verHuella(); else verFigura(); }
    else { state.conFigura = !state.conFigura; if(state.conFigura) verFigura(); else if(state.huella.on) verHuella(); }
    renderPacks(); renderExtra(); renderPrice();
    return;
  }
  const off = e.target.closest("[data-extra].is-off .item__off");
  if(off){ state.huella.on = true; renderPacks(); renderExtra(); renderPrice(); verHuella(); return; }
  const hc = e.target.closest("[data-hcolor]");
  if(hc){ state.huella.color = +hc.dataset.hcolor; renderExtra(); renderPrice(); verHuella(); return; }
  const hp = e.target.closest("[data-hpack]");
  if(hp){ state.huella.pack = +hp.dataset.hpack; renderPacks(); renderExtra(); renderPrice(); verHuella(); return; }

  const q = e.target.closest(".faq__q");
  if(q){ toggleFaq(q); return; }

  const thumb = e.target.closest(".galeria__thumbs button");
  if(thumb){ setVista(thumb); return; }

  const add = e.target.closest("[data-add]");
  if(add){ addToCart(); return; }
});

/* desplegable de productos en la cabecera */
function setMenu(menu, open){
  menu.classList.toggle("is-open", open);
  const b = menu.querySelector(".nav__trigger");
  if(b) b.setAttribute("aria-expanded", String(open));
}
document.addEventListener("click", e => {
  const trigger = e.target.closest(".nav__trigger");
  $$(".nav__menu").forEach(m => {
    if(trigger && m.contains(trigger)) setMenu(m, !m.classList.contains("is-open"));
    else if(!m.contains(e.target) || e.target.closest(".nav__panel a")) setMenu(m, false);
  });
});
document.addEventListener("keydown", e => {
  if(e.key !== "Escape") return;
  $$(".nav__menu.is-open").forEach(m => { setMenu(m, false); m.querySelector(".nav__trigger").focus(); });
});
document.addEventListener("focusin", e => {
  $$(".nav__menu.is-open").forEach(m => { if(!m.contains(e.target)) setMenu(m, false); });
});

function toggleFaq(btn){
  const item = btn.closest(".faq__item");
  const panel = item.querySelector(".faq__a");
  const open = item.classList.toggle("is-open");
  btn.setAttribute("aria-expanded", String(open));
  if(open){
    panel.style.height = panel.scrollHeight + "px";
    panel.addEventListener("transitionend", function done(){
      panel.style.height = "auto";
      panel.removeEventListener("transitionend", done);
    });
  }else{
    panel.style.height = panel.scrollHeight + "px";
    requestAnimationFrame(() => { panel.style.height = "0px"; });
  }
}

/* El pack entra en el carrito como figuras sueltas (2 x "1 unidad") y el
   precio del pack lo ponen los descuentos automáticos de la tienda, que
   cuentan todas las del carrito: así una golden y un caniche por separado
   cuestan lo mismo que un pack de 2. Si no hay variante suelta, la del pack. */
function cartLine(){
  const v = currentVariant(), n = PACKS[state.pack] ? PACKS[state.pack].qty : 1;
  const i = PACKS.findIndex(p => p.qty === 1);
  const one = n > 1 && i >= 0 ? variantAt(state.format, i) : null;
  return one && one.opt1 === v.opt1 ? { id: one.id, quantity: n } : { id: v.id, quantity: 1 };
}

async function addToCart(){
  const v = currentVariant();
  if(!v) return;
  /* la figura (si está encendida) y el llavero de huella (si lo está) */
  const items = [...(figuraOn() ? [cartLine()] : []), ...huellaLineas()];
  if(!items.length) return;
  /* el tono elegido, para que el carrito pinte cada pieza como se configuró */
  try{
    const f = FUR[state.fur];
    localStorage.setItem("pk-tono", JSON.stringify(f && !f.empty ? { c: f.c, d: f.d } : { vacia: true }));
  }catch(e){}
  const btns = $$("[data-add]");
  btns.forEach(b => b.disabled = true);
  try{
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    });
    if(!r.ok) throw new Error(await r.text());
    toast(t("toast.added") + " · " + money(pedidoTotal(), state.lang));
    setTimeout(() => { window.location.href = "/cart"; }, 900);
  }catch(err){
    console.error(err);
    toast(state.lang === "es"
      ? "No se ha podido añadir. Inténtalo de nuevo."
      : "Couldn't add it. Please try again.");
    btns.forEach(b => b.disabled = false);
  }
}

let toastTimer;
function toast(msg){
  const el = $("#toast");
  el.textContent = msg;
  el.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove("is-visible"), 2600);
}

/* header pegajoso + barra fija móvil */
const header = $("#header");
const sticky = $("#stickyBuy");
const buySection = $("#producto");

/* Un solo bucle por frame para todo lo que depende del scroll o del
   puntero. Cada tarea lee medidas en read() y escribe estilos en write():
   primero todas las lecturas, luego todas las escrituras. */
const frame = (() => {
  const jobs = new Set();
  let id = 0;
  const run = t => {
    id = 0;
    const list = [...jobs];
    list.forEach(j => j.read && j.read(t));
    list.forEach(j => j.write && j.write(t));
  };
  const request = () => { if(!id) id = requestAnimationFrame(run); };
  window.addEventListener("scroll", request, { passive:true });
  window.addEventListener("resize", request, { passive:true });
  return {
    add(j){ jobs.add(j); request(); return j; },
    remove(j){ jobs.delete(j); },
    request
  };
})();

frame.add({
  read(){
    this.y = window.scrollY;
    /* La compra esta arriba del todo: la barra solo tiene sentido cuando ya la has
       dejado atras. Antes se asomaba doscientos pixeles y volvia a irse. */
    this.past = !!(sticky && buySection) && buySection.getBoundingClientRect().bottom < 0;
  },
  write(){
    if(header) header.classList.toggle("is-stuck", this.y > 16);
    if(sticky) sticky.classList.toggle("is-visible", this.past);
  }
});

/* ---------- pagina de productos: pestañas ---------- */
const tabs = $$("[data-tab]");

function showProduct(i){
  if(!PKP || !PKP[i]) return;
  useCatalog(PKP[i]);
  state.format = 0;
  state.pack = Math.min(state.pack, Math.max(PACKS.length - 1, 0));
  tabs.forEach((b, j) => {
    b.setAttribute("aria-selected", String(j === i));
    b.tabIndex = j === i ? 0 : -1;
  });
  $$("[data-prod]").forEach(el => { el.hidden = +el.dataset.prod !== i; });
  const panel = $("#tienda-panel");
  if(panel && tabs[i]) panel.setAttribute("aria-labelledby", tabs[i].id);
}

function tabFromHash(){
  const i = tabs.findIndex(b => "#" + b.dataset.slug === location.hash);
  return i < 0 ? 0 : i;
}

function goTab(i, focus){
  showProduct(i);
  renderStatic(); renderFormats(); renderPacks(); renderPrice();
  if(window.pkMotion) window.pkMotion.onTab();
  if(tabs[i]){
    history.replaceState(null, "", "#" + tabs[i].dataset.slug);
    if(focus) tabs[i].focus();
  }
}

if(PKP && tabs.length){
  showProduct(tabFromHash());
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-tab]");
    if(b) goTab(+b.dataset.tab);
  });
  /* flechas, Inicio y Fin, como un tablist de verdad */
  $("[role=tablist]").addEventListener("keydown", e => {
    const cur = tabs.findIndex(b => b.getAttribute("aria-selected") === "true");
    const n = tabs.length;
    const next = { ArrowRight:(cur + 1) % n, ArrowLeft:(cur - 1 + n) % n, Home:0, End:n - 1 }[e.key];
    if(next === undefined) return;
    e.preventDefault();
    goTab(next, true);
  });
  window.addEventListener("hashchange", () => goTab(tabFromHash()));
}

/* ============================================================
   arranque
   ============================================================ */

renderAll();

/* El bloque #tambien solo existe en la portada. En la ficha de producto los
   enlaces apuntan a /#tambien, que si existe, asi que solo se quitan los que
   apuntan a un ancla de esta misma pagina. */
if(!document.getElementById("tambien")){
  $$("[data-cross-nav]").forEach(el => {
    if(!(el.getAttribute("href") || "").startsWith("#")) return;
    (el.closest("li") || el).remove();
  });
}

frame.request();

/* ============================================================
   motion
   Un solo runtime, aparte de la logica comercial. La coreografia
   (que se mueve, cuanto y con que curva) esta en styles.css; aqui
   solo se decide cuando. Sin JS todo se ve. Con "reducir
   movimiento" no se oculta nada ni se mueve nada por scroll o
   puntero, y la compra, el FAQ y la navegacion siguen iguales.
   ============================================================ */

const MQ = {
  reduce:  matchMedia("(prefers-reduced-motion: reduce)"),
  fine:    matchMedia("(hover: hover) and (pointer: fine)"),
  mobile:  matchMedia("(max-width: 760px)"),
  desktop: matchMedia("(min-width: 1081px)"),
  scene:   matchMedia("(min-width: 1081px) and (min-height: 600px)")
};
const clamp01 = v => Math.min(1, Math.max(0, v));
const easeOut = t => 1 - Math.pow(1 - t, 3);
const easeInOut = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
const EASE_CSS = { out:"cubic-bezier(.22,.61,.36,1)", cine:"cubic-bezier(.16,1,.3,1)", exit:"cubic-bezier(.7,0,.84,0)" };

const motion = {
  on: false,
  io: null,
  undo: [],              // todo lo que el runtime pone o escucha, para quitarlo
  refresh: [],           // lo que hay que rehacer al cambiar de idioma
  split: new Map(),      // titular partido -> temporizador que lo deshace
  orig: new Map(),       // titular partido -> su HTML original
  owned: new WeakSet()   // elementos que mueve una escena y no la entrada generica
};
const motionAllowed = () => !MQ.reduce.matches;

function listen(el, type, fn, opt){
  el.addEventListener(type, fn, opt);
  motion.undo.push(() => el.removeEventListener(type, fn, opt));
}
function addJob(job){
  frame.add(job);
  motion.undo.push(() => frame.remove(job));
  return job;
}
function msVar(el, name){
  const v = getComputedStyle(el).getPropertyValue(name).trim(), n = parseFloat(v) || 0;
  return /ms$/.test(v) ? n : /s$/.test(v) ? n * 1000 : n;
}

/* ---------- titulares por lineas ----------
   Se parten justo antes de animar, midiendo donde cae cada palabra con la
   fuente ya cargada, y se devuelven a su HTML original al terminar: asi un
   cambio de ancho no deja lineas mal cortadas. Las lineas visuales van
   aria-hidden; el texto entero queda en un span para lectores de pantalla. */
const FONT_TEST = '600 1em "Fraunces"';
function fontsReady(max){
  if(!document.fonts || !document.fonts.ready) return Promise.resolve();
  return Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, max))]);
}

function splitTitle(el){
  if(!document.fonts || !document.fonts.check(FONT_TEST)) return false;
  const html = el.innerHTML;
  const tmp = document.createElement("div");
  tmp.innerHTML = html.replace(/<br\s*\/?>/gi, " ");
  const text = tmp.textContent.replace(/\s+/g, " ").trim();

  /* 1) cada palabra en un span medible; se apunta si iba separada de la anterior */
  const words = [];
  let gap = true;
  (function wrap(node){
    [...node.childNodes].forEach(n => {
      if(n.nodeType === 3){
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(part => {
          if(!part) return;
          if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); gap = true; return; }
          const w = document.createElement("span");
          w.textContent = part;
          words.push({ w, gap });
          gap = false;
          frag.appendChild(w);
        });
        n.replaceWith(frag);
      }else if(n.nodeName === "BR") gap = true;
      else if(n.nodeType === 1) wrap(n);
    });
  })(el);
  if(!words.length){ el.innerHTML = html; return false; }

  /* 2) agrupar por la linea en la que han caido */
  const lines = [];
  let top = null;
  words.forEach(o => {
    const t = o.w.getBoundingClientRect().top;
    if(top === null || t > top + 4){ lines.push([]); top = t; }
    lines[lines.length - 1].push(o);
  });

  /* 3) reescribir cada linea conservando <em> y demas marcas en linea */
  const esc = v => v.replace(/&/g, "&amp;").replace(/</g, "&lt;");
  const shell = e => { const h = e.cloneNode(false).outerHTML, i = h.lastIndexOf("</"); return [h.slice(0, i), h.slice(i)]; };
  const chain = w => { const c = []; for(let n = w.parentNode; n && n !== el; n = n.parentNode) c.unshift(n); return c; };
  const out = lines.map((ws, i) => {
    let s = "";
    const open = [];
    ws.forEach((o, k) => {
      const ch = chain(o.w);
      let c = 0;
      while(c < open.length && open[c] === ch[c]) c++;
      for(let j = open.length - 1; j >= c; j--) s += shell(open[j])[1];
      open.length = c;
      if(k && o.gap) s += " ";
      for(let j = c; j < ch.length; j++){ s += shell(ch[j])[0]; open.push(ch[j]); }
      s += esc(o.w.textContent);
    });
    for(let j = open.length - 1; j >= 0; j--) s += shell(open[j])[1];
    return `<span class="m-line" style="--i:${i}"><span class="m-line__in">${s}</span></span>`;
  }).join("");

  motion.orig.set(el, html);
  el.innerHTML = `<span class="visually-hidden">${esc(text)}</span><span class="m-lines" aria-hidden="true">${out}</span>`;
  el.classList.add("m-split");
  return true;
}

/* keep = el texto de dentro ya es otro (cambio de idioma): no se restaura el viejo */
function unsplitTitle(el, keep){
  clearTimeout(motion.split.get(el));
  motion.split.delete(el);
  if(!keep && motion.orig.has(el)) el.innerHTML = motion.orig.get(el);
  motion.orig.delete(el);
  el.classList.remove("m-split", "m-in");
}

function initTitleSplits(){
  motion.refresh.push(() => motion.split.forEach((t, el) => unsplitTitle(el, true)));
}

/* ---------- entradas ----------
   Primera pantalla: arranca al tener las fuentes (como mucho 450 ms), con
   los retardos que marca el CSS. Si el navegador ya ha pintado la pagina
   antes de llegar aqui, no se esconde lo que ya se ha visto.
   El resto: .m-pre ahora (esta fuera de pantalla) y se revela al entrar. */
const MOTION_SEL = "[data-motion-title],[data-motion-group],[data-motion-media]";

function reveal(el){
  if(!el.classList.contains("m-pre")) return;
  if(el.hasAttribute("data-motion-title") && splitTitle(el)){
    el.classList.remove("m-pre");
    void el.offsetWidth;                         // las lineas parten de su mascara
    el.classList.add("m-in");
    const n = el.querySelectorAll(".m-line").length;
    const total = msVar(el, "--m-delay") + (n - 1) * (msVar(el, "--m-stagger") || 90) + 780;
    motion.split.set(el, setTimeout(() => unsplitTitle(el), total));
    return;
  }
  el.classList.add("m-in");
  el.classList.remove("m-pre");
  setTimeout(() => el.classList.remove("m-in"), 2400);
}

function initEntrances(){
  const vh = window.innerHeight;
  const painted = !!(performance.getEntriesByName && performance.getEntriesByName("first-contentful-paint").length);
  const now = [], later = [];
  $$(MOTION_SEL).forEach(el => {
    if(motion.owned.has(el) || el.closest("[hidden]")) return;
    const r = el.getBoundingClientRect();
    if(r.bottom <= 0 || (r.top < vh && painted)) return;
    (r.top < vh ? now : later).push(el);
  });
  now.concat(later).forEach(el => el.classList.add("m-pre"));

  if(now.length) fontsReady(450).then(() => requestAnimationFrame(() => { if(motion.on) now.forEach(reveal); }));
  if(later.length && "IntersectionObserver" in window){
    motion.io = new IntersectionObserver(es => es.forEach(e => {
      if(!e.isIntersecting) return;
      motion.io.unobserve(e.target);
      reveal(e.target);
    }), { rootMargin:"0px 0px -12% 0px" });
    later.forEach(el => motion.io.observe(el));
  }else later.forEach(el => el.classList.remove("m-pre"));
}

/* ---------- cabecera ----------
   Fuera del hero, al bajar mas de 80 px seguidos se aparta; al subir vuelve.
   Nunca en movil, ni con el foco o el raton dentro, ni con el desplegable
   abierto. */
function initHeaderMotion(){
  if(!header) return;
  const heroes = $$('[data-motion-stage="hero"],[data-motion-stage="huella"]');
  let lastY = window.scrollY, acc = 0, hidden = false;
  listen(header, "focusin", frame.request);
  addJob({
    read(){
      const y = window.scrollY, dy = y - lastY;
      lastY = y;
      if(dy > 0) acc = Math.max(0, acc) + dy;
      else if(dy < 0) acc = Math.min(0, acc) + dy;
      const inHero = heroes.length
        ? heroes.some(h => { const r = h.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; })
        : y < 240;
      const keep = MQ.mobile.matches || inHero || header.matches(":focus-within, :hover") ||
                   !!header.querySelector(".nav__menu.is-open");
      if(keep || acc < -6) hidden = false;
      else if(acc > 80) hidden = true;
    },
    write(){ header.classList.toggle("is-hidden", hidden); }
  });
  motion.undo.push(() => header.classList.remove("is-hidden"));
}

/* ---------- profundidad del hero con el puntero ----------
   Solo raton. Mueve el envoltorio [data-motion-pointer]; dog.js sigue
   escribiendo su transform en .escena__mover, que va dentro. */
function initHeroPointerDepth(){
  if(!MQ.fine.matches) return;
  $$("[data-motion-pointer]").forEach(initPointerDepth);
}
function initPointerDepth(wrap){
  const hero = wrap.closest("section");
  if(!hero) return;
  const cur = { x:0, y:0 }, tg = { x:0, y:0 };
  let inside = false, last = 0, drawn = "";
  listen(hero, "pointermove", e => {
    if(e.pointerType !== "mouse") return;
    inside = true;
    tg.x = Math.max(-1, Math.min(1, e.clientX / window.innerWidth * 2 - 1));
    tg.y = Math.max(-1, Math.min(1, e.clientY / window.innerHeight * 2 - 1));
    frame.request();
  }, { passive:true });
  listen(hero, "pointerleave", () => { inside = false; tg.x = tg.y = 0; frame.request(); });
  addJob({
    write(t){
      if(cur.x === tg.x && cur.y === tg.y && !last) return;
      const dt = last ? Math.min(64, t - last) : 16;
      last = t;
      /* sigue al raton en ~140 ms; al salir vuelve a reposo en unos 600 ms */
      const k = 1 - Math.exp(-dt / (inside ? 140 : 200));
      cur.x += (tg.x - cur.x) * k;
      cur.y += (tg.y - cur.y) * k;
      const done = Math.abs(tg.x - cur.x) < .002 && Math.abs(tg.y - cur.y) < .002;
      if(done){ cur.x = tg.x; cur.y = tg.y; last = 0; }
      const v = cur.x || cur.y
        ? `translate3d(${(cur.x * 6).toFixed(2)}px,${(cur.y * 5).toFixed(2)}px,0) rotateX(${(-cur.y * 1.2).toFixed(3)}deg) rotateY(${(cur.x * 1.2).toFixed(3)}deg)`
        : "";
      if(v !== drawn){ wrap.style.transform = v; drawn = v; }
      if(!done) frame.request();
    }
  });
  motion.undo.push(() => { wrap.style.transform = ""; });
}

/* ---------- titular del hero a sangre ----------
   En escritorio el titular va detras de la figura; al bajar se aleja algo
   mas rapido que la pagina y se encoge un 6 %, mientras la figura sube. */
function initHeroParallax(){
  $$('[data-motion-stage="hero"],[data-motion-stage="huella"]').forEach((hero, i) => {
    const els = [$("h1, .hero__title", hero), $(".eyebrow", hero)].filter(Boolean);
    if(!els.length) return;
    let v = null, drawn = "";
    addJob({
      read(){
        if(!MQ.desktop.matches){ v = ""; return; }
        const vh = window.innerHeight;
        /* el primero, desde arriba de la página, como siempre; el de la
           huella, desde que su borde de arriba llega al de la pantalla */
        const y = i === 0 ? window.scrollY : -hero.getBoundingClientRect().top;
        if(y > vh * 1.6 || y < -vh){ v = null; return; }       // lejos: no se toca
        v = y > 0 ? `translate3d(0,${(-y * .35).toFixed(1)}px,0) scale(${(1 - Math.min(y / vh, 1) * .06).toFixed(4)})` : "";
      },
      write(){
        if(v === null || v === drawn) return;
        drawn = v;
        els.forEach(e => { e.style.transform = v; });
      }
    });
    motion.undo.push(() => els.forEach(e => { e.style.transform = ""; }));
  });
}

/* ---------- CTA magneticos ----------
   Solo escritorio y solo los CTA grandes sueltos (no el de anadir, ni
   packs, colores, pestanas o la barra movil). El boton no se mueve: se
   mueven la pastilla (hasta 6 px) y el texto, 2 px menos. */
function initMagneticButtons(){
  if(!MQ.fine.matches) return;
  const btns = $$(".btn--primary.btn--lg:not(.btn--block)")
    .filter(b => !b.closest(".packs, .swatches, .tabs, .sticky-buy"));
  if(!btns.length) return;
  const st = new Map();
  const dress = b => {
    const s = st.get(b);
    if(b.querySelector(":scope > .btn__in")) return;
    const bg = document.createElement("span"), label = document.createElement("span");
    bg.className = "btn__bg"; bg.setAttribute("aria-hidden", "true");
    label.className = "btn__in";
    while(b.firstChild) label.appendChild(b.firstChild);
    b.append(bg, label);
    s.bg = bg; s.label = label; s.drawn = "";
  };
  btns.forEach(b => {
    st.set(b, { x:0, y:0, tx:0, ty:0, r:null, bg:null, label:null, drawn:"" });
    b.classList.add("is-magnet");
    dress(b);
    listen(b, "pointerenter", () => { st.get(b).r = b.getBoundingClientRect(); });
    listen(b, "pointermove", e => {
      const s = st.get(b), r = s.r || (s.r = b.getBoundingClientRect());
      const dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
      const d = Math.hypot(dx, dy) || 1, m = Math.min(6, d * .2);
      s.tx = dx / d * m; s.ty = dy / d * m;
      frame.request();
    }, { passive:true });
    listen(b, "pointerleave", () => { const s = st.get(b); s.tx = s.ty = 0; s.r = null; frame.request(); });
  });
  let last = 0;
  addJob({
    write(t){
      const dt = last ? Math.min(64, t - last) : 16;
      let moving = false;
      st.forEach(s => {
        if(s.x === s.tx && s.y === s.ty) return;
        const k = 1 - Math.exp(-dt / (s.tx || s.ty ? 110 : 170));
        s.x += (s.tx - s.x) * k;
        s.y += (s.ty - s.y) * k;
        if(Math.abs(s.tx - s.x) < .01 && Math.abs(s.ty - s.y) < .01){ s.x = s.tx; s.y = s.ty; }
        else moving = true;
        const v = s.x || s.y ? `translate3d(${s.x.toFixed(2)}px,${s.y.toFixed(2)}px,0)` : "";
        if(v === s.drawn) return;
        s.drawn = v;
        if(s.bg) s.bg.style.transform = v;
        if(s.label) s.label.style.transform = v && `translate3d(${(s.x * 2 / 3).toFixed(2)}px,${(s.y * 2 / 3).toFixed(2)}px,0)`;
      });
      last = moving ? t : 0;
      if(moving) frame.request();
    }
  });
  /* renderStatic reescribe el texto del boton: se vuelve a vestir */
  motion.refresh.push(() => btns.forEach(dress));
  motion.undo.push(() => btns.forEach(b => {
    b.classList.remove("is-magnet");
    const label = b.querySelector(":scope > .btn__in"), bg = b.querySelector(":scope > .btn__bg");
    if(label){ while(label.firstChild) b.insertBefore(label.firstChild, label); label.remove(); }
    if(bg) bg.remove();
  }));
}

/* ---------- compra ----------
   Al cambiar color, raza o cantidad: el control pasa de un estado al otro
   (renderizar con innerHTML no deja transicionar), el precio se asienta si
   ha cambiado y un halo muy bajo confirma el cambio. Nada de esto bloquea
   la seleccion ni el carrito. En escritorio, la foto deriva un poco. */
function initPurchaseMotion(){
  const CTL = "[data-swatches] .swatch, [data-shapes] .chip, [data-packs] .pack";
  const look = b => {
    const c = getComputedStyle(b);
    return { backgroundColor:c.backgroundColor, borderColor:c.borderTopColor, color:c.color };
  };
  const same = (a, z) => a.backgroundColor === z.backgroundColor && a.borderColor === z.borderColor && a.color === z.color;
  listen(document, "click", e => {
    const ctl = e.target.closest(CTL);
    if(!ctl || !ctl.animate) return;
    const box = ctl.parentElement, panel = ctl.closest(".buy__panel");
    const before = [...box.children].map(look);
    const price = $("[data-price]", panel || document), was = price && price.textContent;
    /* despues de que app.js haya repintado los controles */
    requestAnimationFrame(() => {
      [...box.children].forEach((b, i) => {
        const a = before[i], z = look(b);
        if(a && !same(a, z)) b.animate([a, z], { duration:200, easing:EASE_CSS.out });
      });
      if(price && price.textContent !== was)
        price.animate([{ opacity:.45, transform:"translateY(4px)" }, { opacity:1, transform:"none" }], { duration:220, easing:EASE_CSS.out });
      if(panel){ panel.classList.remove("is-pulse"); void panel.offsetWidth; panel.classList.add("is-pulse"); }
    });
  }, true);

  /* deriva de la foto: solo en la portada y en escritorio */
  const sec = $('[data-motion-stage="buy"]'), art = sec && $(".buy__art", sec);
  if(!art || !("IntersectionObserver" in window)) return;
  let near = false, t, drawn = "";
  const io = new IntersectionObserver(es => { near = es[0].isIntersecting; frame.request(); });
  io.observe(sec);
  motion.undo.push(() => { io.disconnect(); art.style.transform = ""; });
  addJob({
    read(){
      if(!MQ.desktop.matches){ t = null; return; }
      if(!near){ t = undefined; return; }
      const r = sec.getBoundingClientRect(), vh = window.innerHeight;
      t = clamp01((vh - r.top) / (vh + r.height));
    },
    write(){
      if(t === undefined) return;
      const v = t === null ? "" : `translate3d(0,${(24 - 40 * t).toFixed(2)}px,0) scale(${(1.03 - .03 * t).toFixed(4)})`;
      if(v !== drawn){ art.style.transform = v; drawn = v; }
    }
  });
}

/* ---------- "Como funciona" ----------
   En escritorio es una escena pegada: la cabecera a la izquierda y los tres
   pasos a la derecha, que se encienden uno tras otro con el scroll y se
   apagan a .28 cuando llega el siguiente. Todo es reversible salvo el
   "clic" de la anilla, que es un gesto con duracion propia.
   Si no cabe en un alto de pantalla, o en tablet y movil, lista normal
   y cada paso entra con su IntersectionObserver. */
function initHowItWorksMotion(){
  const sec = $('[data-motion-stage="como"]');
  const box = sec && $("[data-motion-sticky]", sec);
  const steps = sec ? $$(".paso", sec) : [];
  if(!box || steps.length !== 3) return;
  const head = $(".pasos__head", sec), list = $(".pasos__list", sec);
  const P = steps.map(li => ({
    li,
    n: $(".paso__n", li), body: $(".paso__body", li), ill: $(".paso__ill", li),
    icon: $(".paso__ill svg", li), draw: $(".paso__ill--draw svg", li),
    halves: $$(".paso__mitad", li), hilo: $(".paso__hilo", li), line: null
  }));
  let active = false, blocked = "", fin = null;
  let p = -1, last = 0, drawnP = -1, top = 0, height = 1, clicked = false;

  const make = cls => { const s = document.createElement("span"); s.className = cls; s.setAttribute("aria-hidden", "true"); return s; };
  function enter(){
    sec.classList.add("is-scene");
    P.forEach(s => {
      motion.owned.add(s.li);
      s.li.classList.remove("m-pre", "m-in");
      s.line = make("paso__linea");
      s.li.prepend(s.line);
    });
    fin = make("paso__linea paso__linea--fin");
    steps[2].append(fin);
    active = true; p = -1; drawnP = -1;
  }
  function leave(){
    sec.classList.remove("is-scene");
    P.forEach(s => {
      [s.n, s.body, s.ill, s.draw, s.hilo, ...s.halves].forEach(e => e && e.removeAttribute("style"));
      if(s.line){ s.line.remove(); s.line = null; }
    });
    if(fin){ fin.remove(); fin = null; }
    active = false;
  }
  function measure(){
    const key = window.innerWidth + "x" + window.innerHeight + ":" + state.lang;
    const want = MQ.scene.matches && motionAllowed() && blocked !== key;
    if(want && !active) enter();
    if(!want && active) leave();
    /* cabe entero en una pantalla? si no, lista normal para este tamano */
    if(active && Math.max(head.offsetHeight, list.offsetHeight) > box.clientHeight - 24){ blocked = key; leave(); }
    frame.request();
  }

  const seg = (a, b) => clamp01((p - a) / (b - a));
  const IN   = [.14, .40, .70];
  const OUT  = [[.32, .40], [.62, .70], null];
  const LINE = [[.04, .14], [.34, .42], [.64, .72]];
  function render(){
    const f = easeInOut(seg(.94, 1));                 // al final todo se asienta, legible
    P.forEach((s, i) => {
      const a = easeOut(seg(IN[i], IN[i] + .09));
      const o = OUT[i] ? easeInOut(seg(OUT[i][0], OUT[i][1])) : 0;
      let op = a * (1 - .72 * o), y = 20 * (1 - a) - 18 * o;
      op += (1 - op) * f;
      y *= 1 - f;
      const ty = `translate3d(0,${y.toFixed(2)}px,0)`;
      s.n.style.opacity = s.body.style.opacity = s.ill.style.opacity = op.toFixed(3);
      s.body.style.transform = s.ill.style.transform = ty;
      s.n.style.transform = `${ty} scale(${(.92 + .08 * easeOut(seg(IN[i], IN[i] + .07))).toFixed(4)})`;
      s.line.style.transform = `scaleX(${easeOut(seg(LINE[i][0], LINE[i][1])).toFixed(4)})`;
    });
    fin.style.transform = `scaleX(${easeOut(seg(.86, .94)).toFixed(4)})`;
    /* 1 · las tijeras se dibujan */
    if(P[0].draw) P[0].draw.style.strokeDashoffset = (1 - easeOut(seg(.16, .30))).toFixed(4);
    /* 2 · las dos mitades se abren (12 px entre ambas) y se vuelven a juntar */
    const gap = 3.2 * easeOut(seg(.45, .55)) * (1 - easeInOut(seg(.62, .70)));
    P[1].halves.forEach((h, k) => { h.style.transform = gap ? `translate(${(k ? gap : -gap).toFixed(3)}px,0)` : ""; });
    /* 3 · la anilla se dibuja, hace clic y el aro fino del llavero la rodea */
    if(P[2].draw) P[2].draw.style.strokeDashoffset = (1 - easeOut(seg(.72, .82))).toFixed(4);
    if(P[2].hilo) P[2].hilo.style.strokeDashoffset = (1 - easeOut(seg(.83, .94))).toFixed(4);
    if(p >= .82 && !clicked && P[2].icon && P[2].icon.animate){
      clicked = true;
      P[2].icon.animate([{ transform:"none" }, { transform:"scale(1.04,.96)", offset:.26 }, { transform:"none" }],
                        { duration:380, easing:EASE_CSS.cine });
    }
    if(p < .76) clicked = false;
  }

  addJob({
    read(){
      if(!active) return;
      top = sec.getBoundingClientRect().top + window.scrollY;
      height = sec.offsetHeight;
    },
    write(t){
      if(!active) return;
      /* de cuando la seccion asoma (60 % de pantalla) a cuando se suelta */
      const vh = window.innerHeight, a = top - vh * .6, b = top + height - vh;
      const tg = clamp01((window.scrollY - a) / Math.max(1, b - a));
      if(p < 0) p = tg;
      const dt = last ? Math.min(64, t - last) : 16;
      p += (tg - p) * (1 - Math.exp(-dt / 70));
      const done = Math.abs(tg - p) < 1e-4;
      if(done){ p = tg; last = 0; } else last = t;
      if(Math.abs(p - drawnP) > 1e-5){ render(); drawnP = p; }
      if(!done) frame.request();
    }
  });

  listen(window, "resize", measure, { passive:true });
  listen(MQ.scene, "change", measure);
  if("ResizeObserver" in window){
    const ro = new ResizeObserver(() => measure());
    ro.observe(head); ro.observe(list);
    motion.undo.push(() => ro.disconnect());
  }
  motion.refresh.push(() => { blocked = ""; measure(); });
  motion.undo.push(() => { if(active) leave(); });
  measure();
}

/* ---------- fotos ----------
   Cambio de foto de la galeria: la que sale se apaga en 120 ms y la nueva
   entra en 360 ms con un 2,5 % de escala. Misma etiqueta <img>: ni cambia
   el tamano ni hay saltos. Al pasar por una miniatura se precarga su foto. */
const swapTok = new WeakMap();
function swapImage(img, src, alt){
  if(!img || !src) return;
  if(img.getAttribute("src") === src){ img.alt = alt; return; }
  if(!motion.on || !motionAllowed() || !img.animate){ img.src = src; img.alt = alt; return; }
  const tok = {};
  swapTok.set(img, tok);
  const from = getComputedStyle(img).opacity;
  const prev = img.getAnimations ? img.getAnimations() : [];
  const out = img.animate([{ opacity:from }, { opacity:0 }], { duration:120, easing:EASE_CSS.exit, fill:"forwards" });
  prev.forEach(a => a.cancel());
  const pre = new Image();
  pre.src = src;
  const loaded = pre.decode ? pre.decode().catch(() => {}) : Promise.resolve();
  Promise.all([out.finished.catch(() => {}), loaded]).then(() => {
    if(swapTok.get(img) !== tok) return;
    img.src = src; img.alt = alt;
    const show = () => {
      if(swapTok.get(img) !== tok) return;
      img.animate([{ opacity:0, transform:"scale(1.025)" }, { opacity:1, transform:"none" }], { duration:360, easing:EASE_CSS.cine });
      out.cancel();
    };
    (img.decode ? img.decode() : Promise.resolve()).then(show, show);
  });
}

function initGalleryMotion(){
  const seen = new Set();
  listen(document, "pointerover", e => {
    const b = e.target.closest && e.target.closest(".galeria__thumbs button, .pk-thumbs button");
    if(!b || !b.dataset.full || seen.has(b.dataset.full)) return;
    seen.add(b.dataset.full);
    new Image().src = b.dataset.full;
  }, { passive:true });
}

/* ---------- FAQ ----------
   La altura sigue como estaba; con el runtime la respuesta aparece un poco
   despues de abrir y se apaga antes de terminar de cerrarse (CSS). */
function initFaqMotion(){
  const list = $("[data-faq]");
  if(!list) return;
  list.classList.add("is-motion");
  motion.undo.push(() => list.classList.remove("is-motion"));
}

/* ---------- arranque y parada ---------- */
function initPageMotion(){
  if(motion.on) return;
  motion.on = true;
  initFaqMotion();
  if(!motionAllowed()) return;
  initHowItWorksMotion();          // antes que las entradas: la escena se queda sus pasos
  initTitleSplits();
  initHeaderMotion();
  initHeroPointerDepth();
  initHeroParallax();
  initMagneticButtons();
  initPurchaseMotion();
  initGalleryMotion();
  initEntrances();
}

function destroyPageMotion(){
  if(!motion.on) return;
  motion.on = false;
  if(motion.io){ motion.io.disconnect(); motion.io = null; }
  [...motion.split.keys()].forEach(el => unsplitTitle(el));
  $$(".m-pre, .m-in").forEach(el => el.classList.remove("m-pre", "m-in"));
  motion.undo.splice(0).reverse().forEach(f => f());
  motion.refresh = [];
}

function refreshPageMotion(){
  if(motion.on) motion.refresh.forEach(f => f());
}

window.pkSwapImage = swapImage;
window.pkMotion = {
  init: initPageMotion,
  destroy: destroyPageMotion,
  refresh: refreshPageMotion,
  /* pagina de productos: al cambiar de pestana, lo nuevo se asienta */
  onTab(){
    if(!motion.on || !motionAllowed()) return;
    $$("#tienda-panel [data-prod]:not([hidden]), #tienda-panel .price-row").forEach(el => el.animate &&
      el.animate([{ opacity:0, transform:"translateY(8px)" }, { opacity:1, transform:"none" }], { duration:280, easing:EASE_CSS.cine }));
  }
};

/* si cambia la preferencia de movimiento a mitad de visita, se rehace todo */
MQ.reduce.addEventListener && MQ.reduce.addEventListener("change", () => { destroyPageMotion(); initPageMotion(); });
initPageMotion();